import { axiosInstance } from "../../Authentication/AxiosInterceptor";

export type PatchRestrictClientAdminQuestionnaireAccessRequest = {
  restrictClientAdminQuestionnaireAccess: boolean;
};

export type PatchRestrictClientAdminQuestionnaireAccessResponse = {
  restrictClientAdminQuestionnaireAccess: boolean;
  restrictClientAdminQuestionnaireLockedBySub: string | null;
};

export async function patchRestrictClientAdminQuestionnaireAccess(
  areaId: string,
  body: PatchRestrictClientAdminQuestionnaireAccessRequest
): Promise<PatchRestrictClientAdminQuestionnaireAccessResponse> {
  const response = await axiosInstance.patch(
    `PatchRestrictClientAdminQuestionnaireAccess/${areaId}`,
    body
  );
  return response.data;
}
